import React, {useEffect} from "react";
import "./About.css";
import GitHubIcon from '@material-ui/icons/GitHub';
import InstagramIcon from '@material-ui/icons/Instagram';
import FacebookIcon from '@material-ui/icons/Facebook';
import LinkedInIcon from '@material-ui/icons/LinkedIn';


import AOS from "aos";
import "aos/dist/aos.css";


function About() {


  useEffect(() => {
    AOS.init();
    AOS.refresh();
  }, []);

  return (
    <div className="About" id="about">
      <div className="head" data-aos={"fade-up"}>
        <div className="head-main" >
          <h4>01.</h4>
          <h2>About Me</h2>
        </div>
      </div>
      <div className="about-content">

        <div className="about-content-text" data-aos={"fade-up"} data-aos-delay="300">
          <p>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Impedit,
            praesentium. Quasi aliquid error hic ipsum. Lorem ipsum dolor sit
            amet, consectetur adipisicing elit. Facilis, culpa. Lorem ipsum
            dolor sit amet consectetur adipisicing elit. Similique culpa dolorum
            neque accusamus nostrum cum. Lorem ipsum dolor sit amet consectetur
            adipisicing elit. Similique culpa dolorum neque accusamus nostrum
            cum
            <br />
            <br />
            Lorem ipsum dolor sit <span>amet consectetur</span>, adipisicing
            elit. Impedit, praesentium. Quasi aliquid error hic ipsum.{" "}
            <span>Lorem ipsum </span> dolor sit amet, consectetur adipisicing
            elit.
            <br />
            <br />
            Here are the few technologies I've been working with recently:
          </p>
          <ul className="skill-list">
            <li>JavaScript (ES6+)</li>
            <li>React</li>
            <li>HTML and (S)CSS</li>
            <li>PHP</li>
            <li>Python</li>
            <li>MERN Stack</li>
          </ul>
        </div>


        <div className="about-image" data-aos={"fade-up"} data-aos-delay="300">
          <div className="wrapper">
            <div className="image-wrapper">
              <img src="./profile.jpg" />
              <h2>Subhampreet Mohanty</h2>
              <ul>
                <li>
                  <a href="https://github.com/atuljustano">
                    <GitHubIcon fontSize="small"/>
                  </a>
                </li>
                <li>
                  <a href="https://www.instagram.com/atulkprajapati2000/">
                    <InstagramIcon  fontSize="small"/>
                  </a>
                </li>
                <li>
                  <a href="https://twitter.com/atuljustano">
                    <FacebookIcon fontSize="small"/>
                  </a>
                </li>
                <li>
                  <a href="https://www.youtube.com/channel/UCf-KfxuY8PZBSD_8RW2nYsw">
                    <LinkedInIcon fontSize="small"/>
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>
        
      </div>
    </div>
  );
}

export default About;
